
import React, { useEffect } from 'react';
import HeroSection from '@/components/HeroSection';
import FeaturesSection from '@/components/FeaturesSection';
import VisualPreview from '@/components/VisualPreview';
import HowItWorks from '@/components/HowItWorks';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';
import { Ship } from 'lucide-react';

const Index = () => {
  // Initialize intersection observer for scroll animations
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll('.reveal');
    revealElements.forEach((element) => observer.observe(element));

    return () => {
      revealElements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <div className="min-h-screen bg-ocean-50">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-sm z-50 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Ship className="h-8 w-8 text-ocean-600" />
              <span className="ml-2 font-poppins font-semibold text-ocean-800">Dive Quote</span>
            </div>
            
            <div className="hidden md:flex space-x-8">
              <a href="#features" className="text-ocean-600 hover:text-ocean-800 transition-colors">
                Features
              </a>
              <a href="#how-it-works" className="text-ocean-600 hover:text-ocean-800 transition-colors">
                How It Works
              </a>
              <a href="#contact" className="text-ocean-600 hover:text-ocean-800 transition-colors">
                Contact
              </a>
            </div>
          </div>
        </div>
      </nav>
      
      {/* Page content */}
      <HeroSection />
      <FeaturesSection />
      <VisualPreview />
      <HowItWorks />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Index;
